module.exports = __webpack_public_path__ + "static/media/qr-logo.d4b8e9c8.png";